'use strict';

var novicell = novicell || {};

novicell.articleList = novicell.articleList || new function () {

    this.init = function () {
        var element = document.querySelector('#js-article-list');
        if (!element) return;

        var body = document.body;
        var siteNodeId = body.getAttribute('siteNodeId');
        new Vue({
            el: element,
            data: {
                params: {
                    siteNodeId: siteNodeId,
                    pageNumber: 1,
                    itemsPerPage: 15,
                    selectedTag: '*'
                },
                articlesList: {},
                loadingComplete: false
            },
            methods: {
                init: function () {
                    this.list();
                },
                onFilterChange: function () {
                    console.log('filter changed');
                    this.resetParams();
                    this.list();
                },
                list: function () {
                    this.loadingComplete = false;
                    axios
                        .get('/umbraco/api/articlesApi/List', {
                            params: this.params
                        })
                        .then(response => {
                            this.articlesList = response.data;
                            this.loadingComplete = true;
                        })
                        .catch(error => (console.log(error)))
                },
                goToPreviousPage() {
                    this.params.pageNumber--;
                    this.list();
                },
                goToNextPage() {
                    this.params.pageNumber++;
                    this.list();
                },
                resetParams() {
                    this.articlesList = {};
                    this.params.pageNumber = 1;
                },
            },
            beforeMount() {
                this.init()
                console.log('before mount');
            },
            updated() {
                this.$nextTick(function () {
                    if (this.loadingComplete) {
                        calculateArticleList()
                    }
                })
            }
        })
    }

    function calculateArticleList() {
        var articleList = document.querySelector('.article-list');
        if (!articleList) return;

        var articleCards = articleList.querySelectorAll('.article-card');
        if (!articleCards) return;

        var articleCardsLength = articleCards.length;

        articleList.classList.remove('article-list--1-row', 'article-list--2-rows', 'article-list--3-rows');

        if (articleCardsLength >= 0 && articleCardsLength < 4) {
            articleList.classList.add('article-list--1-row')
        }

        if (articleCardsLength > 3) {
            articleList.classList.add('article-list--2-rows')
        }

        if (articleCardsLength > 9) {
            articleList.classList.add('article-list--3-rows')
        }
    }
}
